<template>
   <div class="fc-mega-menu-panel">
      <div v-for="(item, index) in dropdownItems" :key="index" class="fc-mega-menu__group">
         <h3 class="fc-mega-menu__eyebrow">{{ item.header }}</h3>
         <p v-if="item.shortDescription" class="fc-mega-menu__group-caption">
            {{ item.shortDescription }}
         </p>
         <ul
            class="fc-mega-menu__items"
            :class="{
               'fc-mega-menu__items--1col': hasNestedGroup(item.items),
               'fc-mega-menu__items--col-flow': !hasNestedGroup(item.items),
            }"
         >
            <li
               v-for="(link, indexNum) in item.items"
               :key="indexNum"
               :class="{ 'fc-mega-menu__items--framework': link.items && link.items.length }"
            >
               <a
                  v-if="link.header"
                  rel="noopener noreferrer"
                  class="fc-mega-menu__item"
                  :href="link.link"
                  itemprop="url"
                  @click.prevent="goTo(link.link)"
               >
                  <span
                     class="fc-mega-menu__icon"
                     :class="{ 'fc-mega-menu__icon--plain': link.items && link.items.length }"
                  >
                     <span v-if="resolveLinkIcon(link)" v-html="resolveLinkIcon(link)"></span>
                     <i v-else :class="link.icon"></i>
                  </span>
                  <span class="fc-mega-menu__label"
                     >{{ link.header
                     }}<span
                        v-if="link.externalProperties && link.externalProperties.isPopular"
                        class="fc-mega-menu__badge fc-mega-menu__badge--popular"
                        >Popular</span
                     ><span
                        v-if="
                           link.externalProperties &&
                              (link.externalProperties.isNew || link.externalProperties.isnew)
                        "
                        class="fc-mega-menu__badge fc-mega-menu__badge--new"
                        >New</span
                     ><i
                        v-if="link.header === 'WebTestIt'"
                        class="external_link fc-mega-menu__ext"
                     ></i
                  ></span>
               </a>
               <ul
                  v-if="link.items && link.items.length"
                  class="fc-mega-menu__items fc-mega-menu__items--nested"
               >
                  <li v-for="(framework, eleIndex) in frameworkItems(link.items)" :key="eleIndex">
                     <a
                        itemprop="url"
                        class="fc-mega-menu__item"
                        :href="framework.link"
                        @click.prevent="goTo(framework.link)"
                     >
                        <span class="fc-mega-menu__icon fc-mega-menu__icon--plain">
                           <span
                              v-if="resolveLinkIcon(framework)"
                              v-html="resolveLinkIcon(framework)"
                           ></span>
                           <i v-else :class="framework.icon"></i>
                        </span>
                        <span class="fc-mega-menu__label"
                           >{{ framework.header
                           }}<span
                              v-if="isUpdated(framework)"
                              class="fc-mega-menu__badge fc-mega-menu__badge--updated"
                              >Updated</span
                           ></span
                        >
                     </a>
                  </li>
               </ul>
               <a
                  v-if="moreLink(link.items)"
                  itemprop="url"
                  class="fc-mega-menu__more"
                  :href="moreLink(link.items).link"
                  @click.prevent="goTo(moreLink(link.items).link)"
               >
                  {{ moreLink(link.items).header }}
               </a>
            </li>
         </ul>
      </div>
   </div>
</template>

<script>
import { resolveLinkIcon } from '../../util/navIcons';

export default {
   name: 'StylishDropdown',
   props: {
      dropdownItems: {
         type: Array,
         default: () => [],
      },
   },
   methods: {
      hasNestedGroup(items) {
         return (items || []).some(link => link.items && link.items.length);
      },
      frameworkItems(items) {
         return (items || []).filter(item => item.type !== 'cta');
      },
      isUpdated(item) {
         const props = item.externalProperties;
         return !!(props && (props.IsUpdate || props.isUpdate || props.isupdate));
      },
      moreLink(items) {
         return (items || []).find(item => item.type === 'cta') || null;
      },
      resolveLinkIcon,
      goTo(url) {
         const reload = this.$reloadType(url);
         if (!reload) {
            this.$router.push(url).catch(() => {});
         } else {
            this.$openReload(url);
         }
      },
   },
};
</script>
<style scoped>
/* "FusionCharts Suite XT" needs more room than the shared 205px/215px
   columns to stay on one line - widen it here only, since Products/
   Resources' shorter labels don't need it and would just get extra
   empty space. Excludes --nested/--1col (higher specificity than those
   modifier classes alone) so the framework sub-grid and the single-
   column Frameworks wrapper keep their own widths instead of being
   pulled back into two columns by this rule. */
.fc-mega-menu__items:not(.fc-mega-menu__items--nested):not(.fc-mega-menu__items--1col):not(.fc-mega-menu__items--col-flow) {
   grid-template-columns: repeat(2, minmax(172px, 228px));
}
.fc-mega-menu__items--1col {
   grid-template-columns: minmax(172px, 228px);
}
/* Same fix as app.scss's shared --col-flow rule, at this component's wider
   228px column size: reserving a fixed 2 columns here overrode the shared
   rule's own fix (this selector is more specific), so a <=4-item group
   still kept a second, empty column's worth of width. */
.fc-mega-menu__items--col-flow {
   grid-template-columns: none;
   grid-auto-columns: minmax(172px, 228px);
}
.fc-mega-menu__icon--plain svg {
   width: 22px;
   height: 22px;
}
.fc-mega-menu-panel .fc_export:before {
   content: '\E993';
}
.fc_svelte:before {
   content: none;
}
.external_link.fc-mega-menu__ext {
   background-image: url('/public/images/external-link-3.svg');
   height: 12px;
   width: 15px;
   background-repeat: no-repeat;
   background-size: contain;
   display: inline-block;
   margin-left: 4px;
   vertical-align: middle;
}
</style>
